import { useState } from 'react'
import styles from './ProgressiveImage.module.scss'

const imageDimensions = {
  'cauterization1.webp': [1200, 1600],
  'cauterization2.webp': [960, 1280],
  'childrensHaircuts1.webp': [1200, 1600],
  'childrensHaircuts2.webp': [1200, 1600],
  'childrensHaircuts3.webp': [1600, 1200],
  'coldBotox1.webp': [960, 1280],
  'coldBotox2.webp': [1200, 1600],
  'coldBotox3.webp': [944, 1537],
  'coldBotox4.webp': [1200, 1600],
  'dyeing1.webp': [1200, 1600],
  'dyeing2.webp': [1200, 1600],
  'dyeing3.webp': [1200, 1600],
  'dyeing4.webp': [1200, 1600],
  'dyeing5.webp': [1200, 1600],
  'dyeing6.webp': [960, 1280],
  'eveningMakeup1.webp': [1200, 1600],
  'hairstyles1.webp': [1200, 1600],
  'hairstyles2.webp': [1200, 1600],
  'hairstyles3.webp': [1200, 1600],
  'hotBotox1.webp': [1200, 1600],
  'intensiveRecovery1.webp': [1200, 1600],
  'intensiveRecovery2.webp': [1200, 1600],
  'keratinSmoothing1.webp': [900, 1206],
  'keratinSmoothing2.webp': [1200, 1600],
  'mensHaircuts1.webp': [900, 1600],
  'mensHaircuts2.webp': [900, 1600],
  'modeling1.webp': [1200, 1600],
  'modeling2.webp': [1200, 1600],
  'modeling3.webp': [1200, 1600],
  'modeling4.webp': [1200, 1600],
  'pedicureWithCoating1.webp': [1200, 1600],
  'pedicureWithCoating2.webp': [1200, 1600],
  'perm1.webp': [900, 1600],
  'perm2.webp': [900, 1600],
  'perm3.webp': [900, 1600],
  'varnishCoating1.webp': [1200, 1600],
  'varnishCoating2.webp': [1200, 1600],
  'varnishCoating3.webp': [1600, 1200],
  'varnishCoating4.webp': [1600, 1200],
  'womensHaircuts1.webp': [1200, 1600],
  'womensHaircuts2.webp': [1200, 1600],
}

const ProgressiveImage = ({
  src,
  alt,
  className = '',
  wrapperClassName = '',
  width: explicitWidth,
  height: explicitHeight,
  loading = 'lazy',
  fetchPriority,
}) => {
  const [loaded, setLoaded] = useState(false)
  const fileName = src.split('/').pop()
  const [defaultWidth, defaultHeight] = imageDimensions[fileName] || [1200, 1600]
  const width = explicitWidth || defaultWidth
  const height = explicitHeight || defaultHeight

  return (
    <span
      className={`${styles.frame} ${wrapperClassName} ${loaded ? styles.loaded : ''}`}
      style={{ aspectRatio: `${width} / ${height}` }}
    >
      <span className={styles.skeleton} aria-hidden="true" />
      <img
        className={`${className} ${styles.image}`}
        src={src}
        width={width}
        height={height}
        alt={alt}
        loading={loading}
        fetchPriority={fetchPriority}
        decoding="async"
        onLoad={() => setLoaded(true)}
      />
    </span>
  )
}

export default ProgressiveImage
